import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, memo, Children, cloneElement, } from 'react';
const styles = {
    width: '100%',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: '5px 0px',
    color: 'gray',
};
function TableBody({ children, className, style }) {
    const mappedChildren = useMemo(() => {
        return Children.map(children, (child) => cloneElement(child, {
            style: { borderBottom: '0.55px solid #d8d8d8', ...child.props.style },
        }));
    }, [children]);
    return (_jsx("div", { className: className, style: { ...styles, ...style }, children: mappedChildren }));
}
export default memo(TableBody);
